import { render, staticRenderFns } from "./SfPagination.vue?vue&type=template&id=6787953a"
import script from "./SfPagination.vue?vue&type=script&lang=js"
export * from "./SfPagination.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfPagination.vue?vue&type=style&index=0&id=6787953a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "19353f12"
  
)

export default component.exports